module.exports = __webpack_public_path__ + "static/media/vegan-chocolate-chunk.6bf3bef4.png";